import { ArrowLeft, Download, Share2, User, Ticket, Building2, HelpCircle, CheckCircle, AlertCircle, XCircle } from 'lucide-react';
// import { TicketData } from '../models/Ticket';
import { useState } from 'react';
// import { TicketHelpSheet } from './support/TicketHelpSheet';
import { PendingPaymentInfoCard } from './tickets/PendingPaymentInfoCard';
import { PaymentMethodChip } from './tickets/PaymentMethodChip';
import { useNavigation } from '../hooks/useNavigation';

// import { useParams } from 'react-router-dom';
import { useTicketStore } from '../store/ticketStore';

interface DetailRowProps {
  icon: React.ReactNode;
  label: string;
  value: string;
}

const DetailRow = ({ icon, label, value }: DetailRowProps) => {
  return (
    <div className="flex items-start gap-3 py-3 px-4">
      <div className="text-[#6B7280] mt-0.5">
        {icon}
      </div>
      <div className="flex-1">
        <p className="text-xs text-[#6B7280] mb-0.5">{label}</p>
        <p className="font-semibold text-[#111827]">{value}</p>
      </div>
    </div>
  );
};

const QRCard = ({ bookingId, isPending, isExpired }: { bookingId: string; isPending?: boolean; isExpired?: boolean }) => {
  return (
    <div className="bg-white rounded-[16px] border border-[#E5E7EB] p-6 shadow-sm relative">
      <p className="text-center text-sm text-[#6B7280] mb-4">
        Código QR de abordaje
      </p>
      
      {/* QR Code Placeholder */}
      <div className="w-full aspect-square max-w-[240px] mx-auto bg-white border-2 border-[#E5E7EB] rounded-[12px] p-4 mb-4 relative">
        {/* QR Pattern */}
        <svg className="w-full h-full" viewBox="0 0 200 200" fill="none">
          {/* Simple QR-like pattern */}
          <rect x="10" y="10" width="50" height="50" fill="#111827" rx="4" />
          <rect x="70" y="10" width="10" height="10" fill="#111827" rx="2" />
          <rect x="90" y="10" width="10" height="10" fill="#111827" rx="2" />
          <rect x="110" y="10" width="10" height="10" fill="#111827" rx="2" />
          <rect x="140" y="10" width="50" height="50" fill="#111827" rx="4" />
          
          <rect x="10" y="70" width="10" height="10" fill="#111827" rx="2" />
          <rect x="30" y="70" width="10" height="10" fill="#111827" rx="2" />
          <rect x="50" y="70" width="10" height="10" fill="#111827" rx="2" />
          <rect x="90" y="70" width="10" height="10" fill="#111827" rx="2" />
          <rect x="110" y="70" width="10" height="10" fill="#111827" rx="2" />
          <rect x="150" y="70" width="10" height="10" fill="#111827" rx="2" />
          <rect x="170" y="70" width="10" height="10" fill="#111827" rx="2" />
          
          <rect x="10" y="90" width="10" height="10" fill="#111827" rx="2" />
          <rect x="50" y="90" width="10" height="10" fill="#111827" rx="2" />
          <rect x="70" y="90" width="30" height="30" fill="#111827" rx="2" />
          <rect x="110" y="90" width="10" height="10" fill="#111827" rx="2" />
          <rect x="130" y="90" width="10" height="10" fill="#111827" rx="2" />
          <rect x="170" y="90" width="10" height="10" fill="#111827" rx="2" />
          
          <rect x="30" y="110" width="10" height="10" fill="#111827" rx="2" />
          <rect x="130" y="110" width="10" height="10" fill="#111827" rx="2" />
          <rect x="150" y="110" width="10" height="10" fill="#111827" rx="2" />
          
          <rect x="10" y="140" width="50" height="50" fill="#111827" rx="4" />
          <rect x="70" y="140" width="10" height="10" fill="#111827" rx="2" />
          <rect x="90" y="140" width="10" height="10" fill="#111827" rx="2" />
          <rect x="110" y="140" width="10" height="10" fill="#111827" rx="2" />
          <rect x="130" y="140" width="10" height="10" fill="#111827" rx="2" />
          <rect x="150" y="140" width="10" height="10" fill="#111827" rx="2" />
          <rect x="170" y="140" width="10" height="10" fill="#111827" rx="2" />
          
          <rect x="70" y="160" width="10" height="10" fill="#111827" rx="2" />
          <rect x="110" y="160" width="10" height="10" fill="#111827" rx="2" />
          <rect x="150" y="160" width="10" height="10" fill="#111827" rx="2" />
          
          <rect x="90" y="180" width="10" height="10" fill="#111827" rx="2" />
          <rect x="130" y="180" width="10" height="10" fill="#111827" rx="2" />
          <rect x="170" y="180" width="10" height="10" fill="#111827" rx="2" />
        </svg>
        
        {/* Overlay for pending/expired tickets */}
        {(isPending || isExpired) && (
          <div className="absolute inset-0 bg-white/90 rounded-[12px] flex items-center justify-center">
            <div className="text-center px-4">
              <AlertCircle className="w-8 h-8 text-[#FF6A2A] mx-auto mb-2" />
              <p className="text-sm font-semibold text-[#111827]">
                {isPending ? 'No válido hasta confirmar pago' : 'QR no válido'}
              </p>
            </div>
          </div>
        )}
      </div>

      <div className="text-center">
        <p className="text-xs text-[#6B7280]">Folio de reservación</p>
        <p className="font-bold text-[#111827] text-lg tracking-wider">{bookingId}</p>
      </div>
    </div>
  );
};


export const TicketDetailScreen = () => {
  // Obtener ID del ticket desde la URL
  // const { id } = useParams<{ id: string }>();
  const { goBack } = useNavigation();
  
  // Obtener el ticket desde el store
  const selectedTicket = useTicketStore((state) => state.selectedTicket);
  
  // Usar el ticket seleccionado (debería haber sido establecido antes de navegar a esta pantalla)
  const ticket = selectedTicket;
  
  const [, setIsHelpSheetOpen] = useState(false);

  // Si no se encuentra el ticket, mostrar error
  if (!ticket) {
    return (
      <div className="min-h-screen bg-[#F7F8FA] flex items-center justify-center p-4">
        <div className="bg-white rounded-[16px] border border-[#E5E7EB] p-6 shadow-sm text-center">
          <AlertCircle className="w-12 h-12 text-[#FF6A2A] mx-auto mb-4" />
          <h2 className="font-bold text-[#111827] mb-2">Boleto no encontrado</h2>
          <p className="text-[#6B7280] mb-4">No pudimos encontrar el boleto solicitado.</p>
          <button
            onClick={goBack}
            className="px-6 py-3 bg-[#FF6A2A] text-white font-semibold rounded-[12px] hover:bg-[#C2410C] transition-colors"
          >
            Volver
          </button>
        </div>
      </div>
    );
  }

  // Determinar el estado del pago
  const isPending = ticket.status === 'pending' || ticket.status === 'expiring-soon';
  const isExpired = ticket.status === 'expired';
  const isConfirmed = ticket.status === 'confirmed';
const isCancelled = ticket.tabStatus === 'cancelled';
  
  // Mostrar tarjeta de pago solo para métodos de pago diferido
  const showPaymentCard = ticket.paymentMethod === 'link' || ticket.paymentMethod === 'spei';

  return (
    <div className="min-h-screen bg-[#F7F8FA]">
      {/* App Bar */}
      <div className="bg-white border-b border-[#E5E7EB] sticky top-0 z-10">
        <div className="flex items-center gap-3 p-4">
          <button
            onClick={goBack}
            className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-[#F7F8FA] transition-colors"
          >
            <ArrowLeft className="w-6 h-6 text-[#111827]" />
          </button>
          <h1 className="text-lg font-bold text-[#111827]">Boleto</h1>
        </div>
      </div>

      {/* Content */}
      <div className="p-4 space-y-4 pb-28">
        {/* Header Card */}
ù   
        {/* Payment Status Card - Solo para Link/SPEI */}
        {showPaymentCard && isPending && (
          <PendingPaymentInfoCard
paymentDeadline={ticket.paymentDeadline ?? 'Por confirmar'}
            total={ticket.total}
          />
        )}

        {showPaymentCard && isConfirmed && (
          <div className="bg-[#ECFDF5] border-2 border-[#10B981] rounded-[16px] p-5 shadow-sm">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 bg-[#10B981] rounded-full flex items-center justify-center flex-shrink-0">
                <CheckCircle className="w-5 h-5 text-white" />
              </div>
              <div className="flex-1">
                <h3 className="font-bold text-[#111827] mb-1">Pago confirmado</h3>
                <p className="text-sm text-[#047857]">
                  Tu boleto está activo y listo para ser usado.
                </p>
              </div>
            </div>
          </div>
        )}

        {isExpired && (
          <div className="bg-[#F3F4F6] border-2 border-[#9CA3AF] rounded-[16px] p-5 shadow-sm">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 bg-[#6B7280] rounded-full flex items-center justify-center flex-shrink-0">
                <XCircle className="w-5 h-5 text-white" />
              </div>
              <div className="flex-1">
                <h3 className="font-bold text-[#111827] mb-1">Boleto expirado</h3>
                <p className="text-sm text-[#6B7280]">
                  El tiempo límite para completar el pago ha vencido.
                </p>
              </div>
            </div>
          </div>
        )}

        {isCancelled && (
          <div className="bg-[#FEE2E2] border-2 border-[#DC2626] rounded-[16px] p-5 shadow-sm">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 bg-[#DC2626] rounded-full flex items-center justify-center flex-shrink-0">
                <XCircle className="w-5 h-5 text-white" />
              </div>
              <div className="flex-1">
                <h3 className="font-bold text-[#111827] mb-1">Boleto cancelado</h3>
                <p className="text-sm text-[#991B1B]">
                  Este boleto ha sido cancelado.
                </p>
              </div>
            </div>
          </div>
        )}

        {/* Trip Details Card */}
        <div className="bg-white rounded-[16px] border border-[#E5E7EB] shadow-sm overflow-hidden">
          <div className="p-4 border-b border-[#E5E7EB] bg-[#F7F8FA]">
            <h3 className="font-bold text-[#111827]">Detalles del viaje</h3>
          </div>
          <div className="divide-y divide-[#E5E7EB]">
            <DetailRow
              icon={<Building2 className="w-5 h-5" />}
              label="Línea de autobús"
value={ticket.company ?? ticket.busLine}
            />
            <DetailRow
              icon={<Ticket className="w-5 h-5" />}
              label="Unidad"
value={ticket.unit ?? 'N/A'}
            />
            <DetailRow
              icon={<User className="w-5 h-5" />}
              label="Pasajero"
              value={ticket.passengerName}
            />
            <DetailRow
              icon={<Ticket className="w-5 h-5" />}
              label="Asiento"
value={ticket.seat ?? ticket.seatNumber}
            />
            
            {/* Payment Method Row */}
            {ticket.paymentMethod && (
              <div className="flex items-start gap-3 py-3 px-4">
                <div className="flex-1">
                  <p className="text-xs text-[#6B7280] mb-2">Método de pago</p>
<PaymentMethodChip
  method={ticket.paymentMethod === 'paypal' ? 'link' : ticket.paymentMethod}
  cardLast4={ticket.paymentMethod === 'card' ? '1234' : undefined}
  variant="default"
/>
                </div>
              </div>
            )}

            <div className="flex items-center justify-between p-4 bg-[#F7F8FA]">
              <span className="font-semibold text-[#111827]">Total pagado</span>
              <span className="font-bold text-[#111827] text-xl">${ticket.total} MXN</span>
            </div>
          </div>
        </div>

        {/* QR Card */}
        <QRCard 
bookingId={ticket.bookingId ?? ticket.id}
          isPending={isPending} 
          isExpired={isExpired || isCancelled}
        />

        {/* Info Text */}
        {isConfirmed && (
          <div className="bg-[#EFF6FF] border border-[#BFDBFE] rounded-[12px] p-4">
            <p className="text-xs text-[#1E40AF] leading-relaxed">
              <strong>Importante:</strong> Presenta este código QR al abordar. Llega 15 minutos antes de la salida programada.
            </p>
          </div>
        )}
      </div>

      {/* Fixed Bottom Actions */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-[#E5E7EB] p-4 shadow-[0_-4px_12px_rgba(0,0,0,0.05)]">
        <div className="flex gap-3">
          <button className="flex-1 flex items-center justify-center gap-2 py-3 border-2 border-[#E5E7EB] text-[#111827] font-semibold rounded-[12px] hover:bg-[#F7F8FA] transition-colors">
            <Download className="w-5 h-5" />
            Descargar
          </button>
          <button className="flex-1 flex items-center justify-center gap-2 py-3 bg-[#F7F8FA] text-[#111827] font-semibold rounded-[12px] hover:bg-[#E5E7EB] transition-colors">
            <Share2 className="w-5 h-5" />
            Compartir
          </button>
          <button
            onClick={() => setIsHelpSheetOpen(true)}
            className="flex-1 flex items-center justify-center gap-2 py-3 bg-[#F7F8FA] text-[#111827] font-semibold rounded-[12px] hover:bg-[#E5E7EB] transition-colors"
          >
            <HelpCircle className="w-5 h-5" />
            Ayuda
          </button>
        </div>
      </div>

      {/* Help Sheet */}
 
    </div>  
  );
};

export default TicketDetailScreen;
